module.exports = __webpack_public_path__ + "static/logo-fsc-d91a638f25c98f53a990585b408dc1f8.png";